export const preventScrolling = (e: React.FocusEvent) => {
  e.target.addEventListener(
    'wheel',
    (o) => {
      o.preventDefault();
    },
    { passive: false }
  );
};
